<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7001 5.68373L11.9001 2.3254C10.5918 1.40873 8.58345 1.45873 7.32511 2.43373L3.15011 5.69206C2.31678 6.34206 1.65845 7.6754 1.65845 8.7254V14.4754C1.65845 16.6004 3.38345 18.3337 5.50845 18.3337H14.4918C16.6168 18.3337 18.3418 16.6087 18.3418 14.4837V8.83373C18.3418 7.70873 17.6168 6.3254 16.7001 5.68373ZM10.6251 15.0004C10.6251 15.3421 10.3418 15.6254 10.0001 15.6254C9.65845 15.6254 9.37511 15.3421 9.37511 15.0004V12.5004C9.37511 12.1587 9.65845 11.8754 10.0001 11.8754C10.3418 11.8754 10.6251 12.1587 10.6251 12.5004V15.0004Z"
      fill="#292D32"
    />
  </svg>
</template>

<script>
export default {
  name: "DashboardActiveIcon",

  data() {
    return {};
  },
  computed: {},
};
</script>
